import React from "react";
import PropTypes from "prop-types";

export default class CheckboxFacet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false
        };
    }

    handleClick = () => {
        const { checkboxType, handleUpdate } = this.props;
        this.setState({ active: !this.state.active });

        if (checkboxType == 'referenced_projects') {
            handleUpdate({ referencedProjects: !this.state.active });
        }
        else if (checkboxType == 'summer_institute') {
            handleUpdate({ summerInstitute: !this.state.active });
        }
        else if (checkboxType == 'program_report') {
            handleUpdate({ programReport: !this.state.active });
        }
    }

    render() {
        const { checkboxLabel, checkboxType } = this.props;
        const className = 'facets__checkbox ' + checkboxType;

        return (
            <div className={ className }>
                <div className={ this.state.active ? 'facets__checkbox-input facets__checkbox--is-selected' : 'facets__checkbox-input' } onClick={ this.handleClick }>
                    <div className="facets__checkbox-label">
                        { checkboxLabel }
                    </div>
                </div>
            </div>
        );
    }
}

const { string, func, array } = PropTypes;

CheckboxFacet.propTypes = {
    handleUpdate: func,
    checkboxLabel: string,
    checkboxType: string
};
